export default {"src":"/_next/static/media/rank_1.942ab9cc.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};